import { version } from 'antd';
import { omitUndefined } from '../omitUndefined';
import { compareVersions } from './index';
var openVisibleCompatible = function openVisibleCompatible(open, onOpenChange) {
  var props = compareVersions(process.env.ANTD_VERSION || version, '4.23.0') > -1 ? {
    open: open,
    onOpenChange: onOpenChange
  } : {
    visible: open,
    onVisibleChange: onOpenChange
  };
  return omitUndefined(props);
};
export { openVisibleCompatible };